import type { IconData } from '@stacksjs/iconify-core'

export const am4x3: IconData = {
  "body": "<path fill=\"#d90012\" d=\"M0 0h640v160H0z\"/><path fill=\"#0033a0\" d=\"M0 160h640v160H0z\"/><path fill=\"#f2a800\" d=\"M0 320h640v160H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default am4x3
